import { render } from "./EsteirasPage.vue?vue&type=template&id=5f0158bd&scoped=true"
import script from "./EsteirasPage.vue?vue&type=script&lang=js"
export * from "./EsteirasPage.vue?vue&type=script&lang=js"

import "./EsteirasPage.vue?vue&type=style&index=0&id=5f0158bd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f0158bd"]])

export default __exports__